import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class UnsubmitAssignmentMutation {
  constructor(mutationProps, callbacks) {
    this.props = mutationProps;

    const query = this.getQuery();
    const variables = this.getVariables();

    this.graphqlMutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);
  }

  getQuery() {
    return Relay.QL`
        mutation UnsubmitMutation($input_0: UnSubmitInput!, $userId: String) {
          unSubmit(input: $input_0) {
            course {
              coursePerformance(userId: $userId) {
                progressMeasure
                scaledProgressMeasure
                completionStatus
                successStatus
                complete
              }
            }
            card {
              performance(userId: $userId) {
                completionStatus
                successStatus
                progressMeasure
                actualSubmit
              }
              questionAnswers(userId: $userId) {
                rawScore
                actualSubmit
                answer {
                  id
                  pid
                  evaluatedAnswer
                  response
                  dirtyResponse
                  lastUpdatedResponse
                  answerType
                }
              }
            }
            clientMutationId
          }
        }
      `;
  }

  getVariables() {
    return {
      input: {
        rootOfferId: this.props.rootOfferId,
        cardId: this.props.cardId,
        userId: this.props.userId,
        timeStamp: new Date().toISOString()
      },
      userId: this.props.userId
    };
  }

  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          course: this.props.courseRelayId,
          card: this.props.cardRelayId
        }
      }
    ];
  }

  commit() {
    this.graphqlMutation.commit(this.getConfigs());
  }
}
